<template>
    <tr :class="{ warning: is_selected }">
        <td class="collapsing">
            <div class="ui fitted checkbox">
                <input type="checkbox" v-model="is_selected"><label></label>
            </div>
        </td>
        <td>
            {{ driver_commission_report.driver_name }}
        </td>
        <td>
            {{ human_datetime(driver_commission_report.begin_at) }}
        </td>
        <td>
            {{ human_datetime(driver_commission_report.end_at) }}
        </td>
        <td>
            {{ driver_commission_report.total_amount }}
        </td>
        <td>
            {{ human_datetime(driver_commission_report.created_at) }}
        </td>

        <td>
            <router-link
            :to="{name: 'driver_commission_report', params: {identity: driver_commission_report.identity}}"
            class="ui basic primary button"
            >
                {{ $t('ui.general.detail') }}
            </router-link>
            <a href="#" v-if="!is_processing" @click.prevent="delete_driver_commission_report()" class="ui basic red button">
                {{ $t('ui.general.delete') }}
            </a>
            <!-- <button class="ui basic negative button" @click.prevent="delete_driver_commission_report()">{{ $t('ui.general.delete') }}</button> -->
            <div style="display:none;" class="driver_commission_report_print" v-if="is_selected">
                <div ref="printable" class="divided A4">
                    <h1 class="ui header center aligned">提成報告</h1>
                    <table class="ui celled small compact table">
                        <tbody>
                            <tr>
                                <td class="collapsing right aligned">
                                    人&emsp;&emsp;&emsp;&emsp;&emsp;員
                                </td>
                                <td>{{ driver_commission_report.driver_name }}</td>
                                <td class="top aligned" colspan="4" rowspan="1">
                                    <h3 class="ui header center aligned">簽名欄</h3>
                                </td>
                            </tr>
                            <tr>
                                <td class="collapsing right aligned">
                                    期&emsp;&emsp;&emsp;&emsp;&emsp;間
                                </td>
                                <td>{{ human_datetime(driver_commission_report.begin_at) }}&emsp;至&emsp;{{ human_datetime(driver_commission_report.end_at) }}</td>
                                <td class="top aligned" colspan="4" rowspan="3">
                                </td>
                            </tr>
                            <tr>
                                <td class="collapsing right aligned">
                                    總&emsp;&emsp;金&emsp;&emsp;額
                                </td>
                                <td>{{ driver_commission_report.total_amount }} 元</td>
                            </tr>
                            <tr>
                                <td class="collapsing right aligned">
                                    產&emsp;生&emsp;日&emsp;期
                                </td>
                                <td>{{ human_datetime(driver_commission_report.created_at) }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="ui celled small compact table">
                        <thead>
                            <tr>
                                <th :colspan="is_detailed_mode ? 5:4" class="center aligned">
                                    <h3 class="ui header">取&emsp;件&emsp;明&emsp;細</h3>
                                </th>
                            </tr>
                            <tr v-if="is_detailed_mode">
                                <th class="collapsing">序號</th>
                                <th>單號</th>
                                <th>日期</th>
                                <th>重量</th>
                                <th>提成(元)</th>
                            </tr>
                            <tr v-else>
                                <th>總運單數</th>
                                <th>總重量</th>
                                <th>總提成(元)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(commission, index) in driver_commission_report.pick_up_driver_commissions" v-if="is_detailed_mode">
                                <td>{{ index+1 }}</td>
                                <td>{{ commission.core_waybill.number }}</td>
                                <td>{{ human_datetime(commission.created_at) }}</td>
                                <td>{{ commission.core_waybill.weight_in_kilo }}</td>
                                <td>{{ commission.amount }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr v-if="is_detailed_mode">
                                <th colspan="3" class="center aligned">總計</th>
                                <th>{{ sum_weights(driver_commission_report.pick_up_driver_commissions) }}</th>
                                <th>{{ sum_amounts(driver_commission_report.pick_up_driver_commissions) }}</th>
                            </tr>
                            <tr v-if="!is_detailed_mode">
                                <th>{{ driver_commission_report.pick_up_driver_commissions.length }}</th>
                                <th>{{ sum_weights(driver_commission_report.pick_up_driver_commissions) }}</th>
                                <th>{{ sum_amounts(driver_commission_report.pick_up_driver_commissions) }}</th>
                            </tr>
                        </tfoot>
                    </table>
                    <table class="ui celled small compact table">
                        <thead>
                            <tr>
                                <th :colspan="is_detailed_mode ? 5:4" class="center aligned">
                                    <h3 class="ui header">派&emsp;件&emsp;明&emsp;細</h3>
                                </th>
                            </tr>
                            <tr v-if="is_detailed_mode">
                                <th class="collapsing">序號</th>
                                <th>單號</th>
                                <th>日期</th>
                                <th>重量</th>
                                <th>提成(元)</th>
                            </tr>
                            <tr v-else>
                                <th>總運單數</th>
                                <th>總重量</th>
                                <th>總提成(元)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(commission, index) in driver_commission_report.delivery_driver_commissions" v-if="is_detailed_mode">
                                <td>{{ index+1 }}</td>
                                <td>{{ commission.core_waybill.number }}</td>
                                <td>{{ human_datetime(commission.created_at) }}</td>
                                <td>{{ commission.core_waybill.weight_in_kilo }}</td>
                                <td>{{ commission.amount }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr v-if="is_detailed_mode">
                                <th colspan="3" class="center aligned">總計</th>
                                <th>{{ sum_weights(driver_commission_report.delivery_driver_commissions) }}</th>
                                <th>{{ sum_amounts(driver_commission_report.delivery_driver_commissions) }}</th>
                            </tr>
                            <tr v-if="!is_detailed_mode">
                                <th>{{ driver_commission_report.delivery_driver_commissions.length }}</th>
                                <th>{{ sum_weights(driver_commission_report.delivery_driver_commissions) }}</th>
                                <th>{{ sum_amounts(driver_commission_report.delivery_driver_commissions) }}</th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
import moment from 'moment'
export default {
    name: "ProviderDriverCommissionReportsIndexItem",
    props: {
        driver_commission_report: Object,
        is_detailed_mode: Boolean,
    },
    data() {
        return {
            is_processing: false,
            is_selected: false
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
        delete_driver_commission_report() {
            if (confirm(this.$t('ui.notifications.warning.are_you_sure_to_delete_it'))) {
                this.is_processing = true
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_driver_commission_report_delete).parse(
                    {
                        "driver_commission_report_identity": this.driver_commission_report.identity,
                    },
                    "?authorization=" + this.$store.state.provider.node.authorization
                )

                axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }}).then(response => {
                    if (response.data.status == "success") {
                        this.$parent.init()
                        // this.$noty.success("收派件提成報告刪除成功")
                        this.$noty.success(
                            this.$t('ui.notifications.success.delete__name', {
                                name: this.$t('models.driver_commission_reports')
                            })
                        )
                    } else {
                        // this.$noty.error("收派件提成報告刪除失敗")
                        this.$noty.error(
                            this.$t('ui.notifications.error.delete__name', {
                                name: this.$t('models.driver_commission_reports')
                            })
                        )
                    }
                })
                .catch(error => {
                    console.log(error)
                    if (!error.response) {
                        // Network Error
                        this.$noty.error(
                            this.$t('ui.general.network_abnormality')+": "+
                            this.$t('ui.general.server_offline')
                        )
                    } else {
                        this.$noty.error(this.$t('ui.general.network_abnormality')+': ' + error.response.status + error.response.data)
                    }
                })
                this.is_processing = false
            }
        },
        human_datetime(data, format="lll") {
            return moment(data).locale("zh-tw").format(format)
        },
        sum_amounts(commissions) {
            return _.sumBy(commissions, commission => {
                var value = commission.amount
                return parseFloat(value)
            }).toFixed(2)
        },
        sum_weights(commissions) {
            return _.sumBy(commissions, commission => {
                var value = commission.core_waybill.weight_in_kilo
                if (commission.amount < 0) {
                    return parseFloat(value*-1)
                } else {
                    return parseFloat(value)
                }
            }).toFixed(2)
        }
    },
    components: {
    }
}
</script>
